import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import Button from '@mui/material/Button';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import AnimationContainer from '../components/AnimationContainer';
import PageLead from '../components/PageLead';
import PageSection from '../components/PageSection';
import Seo from '../components/Seo';
import Separator from '../components/Separator';

const NoMatch = () => {
  const navigate = useNavigate();
  return <>
    <Seo
      title="Seite nicht gefunden | mk mediaconcept"
      description="Die angeforderte Seite konnte nicht gefunden werden."
      canonical=""
      index={false}
      follow={false}
    />
    <PageSection>
      <Separator />
      <AnimationContainer lazy={() => import('../components/three/PointWaves')} />
      <PageLead>
        <h1>404</h1>
        <p>
          Die angeforderte Seite konnte nicht gefunden werden. 
          Bitte überprüfen Sie die URL oder kehren zur Startseite zurück.
        </p>
        <Button
          color="transparent"
          variant="contained"
          startIcon={<ExitToAppIcon />}
          onClick={() => navigate('/')}
        >
          Zur Startseite
        </Button>
      </PageLead>
    </PageSection>
  </>;
};

export const Component = NoMatch;

export { default as ErrorBoundary } from '../components/ErrorMessage';

export default NoMatch;
